export function previewRequest(jobId: number, headerRowIndex?: number) {
  return { id: jobId, ...(headerRowIndex !== undefined ? { headerRowIndex } : {}) };
}
